import styled from 'styled-components';
import { DarkTheme, LightTheme, ThemeType } from 'src/packages/theme';
import { NavLinkWithDropdownStyles } from '../NavLink.types';

export const getNavlinkWithDropdownStyles = (
  highlightSublinks: boolean,
  theme: ThemeType
): NavLinkWithDropdownStyles => {
  return {
    color: theme === 'dark' ? DarkTheme.colors.text.primary : LightTheme.colors.text.primary,
    iconColor: theme === 'dark' ? DarkTheme.colors.text.tertiary : LightTheme.colors.text.primary,
    sublinksColor:
      theme === 'dark'
        ? highlightSublinks
          ? DarkTheme.colors.text.secondary
          : DarkTheme.colors.palette.white
        : LightTheme.colors.text.primary,
    sublinksWrapperBgColor:
      theme === 'dark'
        ? highlightSublinks
          ? DarkTheme.colors.background.main
          : DarkTheme.colors.palette.black
        : LightTheme.colors.palette.white,
  };
};

export const Collapse = styled.div`
  width: 100%;
  overflow: hidden;
  height: auto;
  transition: all 1.5s linear;

  &.collapsed {
    max-height: 0;
  }

  &.expanded {
    max-height: 1000px;
  }
`;

export const LinkWrapper = styled.div<{ color: string }>`
  width: 100%;
  display: flex;
  flex-direction: column;

  a {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;

    &:focus {
      div {
        color: ${(props) => props.color};
      }
    }

    svg {
      &.red {
        path[stroke] {
          stroke: ${(props) => props.theme.colors.palette.red} !important;
        }

        path[fill] {
          fill: ${(props) => props.theme.colors.palette.red} !important;
        }
      }

      &.orange {
        path[stroke] {
          stroke: ${(props) => props.theme.colors.palette.orange} !important;
        }

        path[fill] {
          fill: ${(props) => props.theme.colors.palette.orange} !important;
        }
      }
    }
  }
`;
